import NodeViewConstructorArgs from '../constructor/NodeViewConstructorArgs';
import AbstractNodeView from './AbstractNodeView';
import * as d3 from 'd3';
import resolution from '../assets/resolution.svg';
import WorkFlowView from '../view/WorkFlowView';
import View from '../view/View';
import { Syntax } from '@trlogic/ui-pack';
import { NodeType, ResolutionCaseType } from '../../../../domain/collection/rule/FlowDomains';
import '../tree.css';

class NotFraudNodeView extends AbstractNodeView {
  public constructor(args: NodeViewConstructorArgs) {
    super(args);
  }

  public initialize(): void {
    this.render();
  }

  public render(): void {
    let node: any;

    if (this.shadow) {
      node = d3.select((this.workFlowView as WorkFlowView).getParent()).append('svg');
    } else {
      node = d3
        .select((this.workFlowView as WorkFlowView).getNode())
        .select('#workflow-container-group')
        .append('g');
    }

    const nodeEnter = node
      .attr('id', this.el.substring(1, this.el.length))
      .attr('data-testid', 'score_input')
      .attr('type', 'notFraud')
      .style('position', 'absolute')
      .style('pointer-events', 'auto')
      .style('width', '50px')
      .style('height', '50px');

    nodeEnter
      .append('rect')
      .attr('width', 50)
      .attr('height', 50)
      .attr('rx', 3)
      .style('stroke', this.getColor())
      .attr('stroke-width', 1)
      .style('fill', 'white')
      .style('stroke-dasharray', '0');

    nodeEnter
      .append('text')
      .attr('x', 50 / 2 + 40)
      .attr('y', 50 / 2 - 2)
      .attr('dy', '.35em')
      .style('fill', '#4F4F4F')
      .text(this.getText());

    nodeEnter
      .append('foreignObject')
      .attr('width', 40)
      .attr('height', 40)
      .attr('x', 5)
      .attr('y', 5)
      .append('xhtml:input')
      .attr('id', 'score_input')
      .style('width', '100%')
      .style('text-align', 'center')
      .style('font-size', '16px')
      .style('border-radius', '25px')
      .style('border', `2px solid ${this.getColor()}`)
      .style('height', '100%')
      .style('color', this.getColor())
      .style('background-color', this.getBackgroundColor())
      .attr('type', 'number')
      .attr('min', 0)
      .attr('max', 100)
      .attr('value', (this.getModel().value as any).score)
      .on('input', (event: any) => {
        let inputValue = event.target.value;
        if (inputValue > 100) {
          event.target.value = 100;
          inputValue = 100;
        }
        if (inputValue < 0) {
          event.target.value = 0;
          inputValue = 0;
        }
        if (inputValue == '') {
          inputValue = 0;
        }
        (this.workFlowView as WorkFlowView).addResolutionScore(ResolutionCaseType.CASE_TRUE, parseInt(inputValue));
        this.setTextAndRender();
        this.nodeRender();
      })
      .on('focus', function () {
        node.select('foreignObject').select('input').style('outline', 'none');
      });

    const status = this.getModel<any>().value.status;
    if (status === false) {
      d3.selectAll(this.getNode()).select('rect').style('stroke', '#bdbdbd').style('stroke-dasharray', '6');
      d3.selectAll(this.getNode()).select('text').style('fill', '#bdbdbd');
      nodeEnter.append('svg:image').attr('xlink:href', resolution).attr('width', 40).attr('height', 40).attr('x', 6).attr('y', 6);
    }
  }

  private setTextAndRender() {
    const node = d3.select(this.el);
    node.select('text').text(this.getText());
    node
      .select('foreignObject')
      .select('input')
      .style('color', this.getColor())
      .style('border', `2px solid ${this.getColor()}`)
      .style('background-color', this.getBackgroundColor());
  }

  private nodeRender() {
    const node = d3.select(this.el);
    const rectElement = node.select('rect');
    rectElement.style('stroke', this.getColor());
  }

  public socketHighlight(type?: NodeType) {}

  public socketUnHighlight(): void {}

  protected preSwap(target: View<Syntax>): boolean {
    switch (target.constructor) {
      case NotFraudNodeView:
        return true;
      default:
        return false;
    }
  }

  public setModel(model: Syntax) {
    d3.select(this.el)
      .select('text')
      .text((model.value as any).name);
  }

  private getText = () => {
    const score: number = (this.getModel().value as any).score;
    if (!this.getModel<any>().value.status) {
      return this.getModel<any>().value.name;
    } else if (score == 0) {
      return 'Approve';
    } else if (score > 0 && score < 100) {
      return 'Escalate';
    } else if (score == 100) {
      return 'Decline';
    } else {
      return this.getModel<any>().value.name;
    }
  };

  private getColor = () => {
    const score: number = (this.getModel().value as any).score;
    if (!this.getModel<any>().value.status) {
      return 'white';
    } else if (score == 0) {
      return '#3D8A55';
    } else if (score > 0 && score < 100) {
      return '#F09D45';
    } else if (score == 100) {
      return '#D92D20';
    } else {
      return '#bdbdbd';
    }
  };

  private getBackgroundColor = () => {
    const score: number = (this.getModel().value as any).score;
    if (!this.getModel<any>().value.status) {
      return 'white';
    } else if (score == 0) {
      return '#ECFDF3';
    } else if (score > 0 && score < 100) {
      return '#FFF8E4';
    } else if (score == 100) {
      return '#FFEDEC';
    } else {
      return 'white';
    }
  };
}

export default NotFraudNodeView;
